import React, {Component} from "react"
import {withTranslation} from "react-i18next"

class IntroSection extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hidden: localStorage.getItem(this.props.image)
    }
  }

  hideIntroText() {
    this.setState({hidden: true})
    localStorage.setItem(this.props.image, true)
  }

  render() {
    if (this.state.hidden) {
      return null
    }

    return (
      <div className="sh-intro-section">
        <div className="sh-intro-section-text">{this.props.children}</div>
        <div className="sh-intro-section-image">
          <img src={this.props.image} alt={this.props.alt} />
          <div className="sh-close-button" onClick={() => this.hideIntroText()}>
            {this.props.t("close")}
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation()(IntroSection)



// WEBPACK FOOTER //
// ./src/components/decorators/IntroSection.js